import React from "react";

export const InitReactorCX = () =>{

  if(typeof window.Rakanto == 'undefined'){
    const script = document.createElement('script');
    script.src = process.env.REACT_APP_REACTOR_SCRIPT_URL;
    script.id = 'rakanto';
    script.async = true;
    const DARID = process.env.REACT_APP_DARID
    if(DARID != null){
     script.setAttribute('data-px-darids', DARID);
    }
    const m = document.getElementsByTagName('script')[0];
    m.parentNode.insertBefore(script, m);
    script.onload = () => {
    if (!window.hasOwnProperty("Rakanto")) {
      window['RakantoObject'] = 'Rakanto'
  
      window.Rakanto = function () {
        (window.Rakanto.q = window.Rakanto.q || []).push([Date.now()].concat(Array.prototype.slice.call(arguments)))
      }
      window.Rakanto.l = Date.now();
    }
  };
  }
}

export default InitReactorCX